import { isDefined } from '@sgme/fp';
import { ORDER_TYPES, OrderType } from 'apiConnector/secondary-market/batch/model';
import { IntlKey } from 'locales';
import { SearchType } from 'state/workspaces/secondary-market/batch/model';

export function toIntlKey(searchType: SearchType): IntlKey {
  return ['secondaryMarket.batch.codeType', searchType.source, searchType.subtype, 'label']
    .filter(isDefined)
    .join('.') as IntlKey;
}

export function isOrderType(orderType: string | undefined): orderType is OrderType {
  return ORDER_TYPES.includes(orderType as OrderType);
}
